function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeed1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(229, 26, 148)",
      fill: "rgb(229, 26, 148)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "13.9819px"
    },
    transform: "matrix(-0.719964, 0.317171, -0.317171, -0.719964, 818.77594, 426.84491)",
    d: "M 774.155 310.234 A 276.086 276.086 0 1 1 570.984 221.084 L 570.984 230.573 A 266.597 266.597 0 1 0 767.172 316.659 Z",
    bxShape: "pie 570.984 497.17 266.597 276.086 47.383 360 1@2c08b409"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "rgb(31, 48, 109)",
      stroke: "rgb(31, 48, 109)",
      strokeWidth: "41.9353px"
    },
    transform: "matrix(-0.567385, 0.249954, -0.249954, -0.567385, 698.237488, 389.367065)",
    d: "M 774.155 310.234 A 276.086 276.086 0 0 1 684.127 749.008 L 680.238 740.352 A 266.597 266.597 0 0 0 767.172 316.659 Z",
    bxShape: "pie 570.984 497.17 266.597 276.086 47.383 155.807 1@f5759bcb"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(229, 26, 148)"
    },
    cx: 250,
    cy: 250,
    r: 17.381
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      stroke: "rgb(229, 26, 148)",
      strokeWidth: 18
    },
    x1: 198.203,
    y1: 198.203,
    x2: 249.493,
    y2: 249.493
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgba(31, 48, 109, 0.74)",
      stroke: "rgb(142, 151, 185)",
      strokeWidth: 3,
      strokeLinecap: "round"
    },
    x1: 250,
    y1: 286.188,
    x2: 250,
    y2: 305.173,
    transform: "matrix(0.707107, 0.707107, -0.707107, 0.707107, 163.889899, -17.499287)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgba(31, 48, 109, 0.74)",
      stroke: "rgb(142, 151, 185)",
      strokeWidth: 3,
      strokeLinecap: "round"
    },
    x1: 94.105,
    y1: 303.178,
    x2: 94.105,
    y2: 322.163,
    transform: "matrix(0.358908, 0.933373, -0.933373, 0.358908, 352.168248, 112.615619)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgba(31, 48, 109, 0.74)",
      stroke: "rgb(142, 151, 185)",
      strokeWidth: 3,
      strokeLinecap: "round"
    },
    x1: 80.929,
    y1: 240.478,
    x2: 80.929,
    y2: 259.463,
    transform: "matrix(0, 1, -1, 0, 330.899506, 169.041504)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgba(31, 48, 109, 0.74)",
      stroke: "rgb(142, 151, 185)",
      strokeWidth: 3,
      strokeLinecap: "round"
    },
    x1: 94.01,
    y1: 176.257,
    x2: 94.01,
    y2: 195.242,
    transform: "matrix(-0.393046, 0.919519, -0.919519, -0.393046, 301.760419, 172.313611)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed1);
export default __webpack_public_path__ + "static/media/Speed1.d88c0e7e31275033ee7879922c151b8c.svg";
export { ForwardRef as ReactComponent };